import { Box, FormControl, InputAdornment, ListSubheader, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import { AlertTemplate, CommunicationChannel } from '../../interfaces/IAlert'
import { ReactNode } from 'react'

interface Props {
  disabled?: boolean
  placeholder?: string
  variant?: 'standard' | 'outlined' | 'filled'
  icon?: ReactNode
  title?: string
  templates?: AlertTemplate[]
  name: string
  defaultValue?: string
  value?: number
  required?: boolean
  onChange: (value: any) => void
}

function AlertTemplateSelectField({ disabled, placeholder, variant, icon, title, templates, name, defaultValue, value, required, onChange }: Props) {
  const emailTemplates = templates?.filter((template) => template.channel === CommunicationChannel.Email)
  const smsTemplates = templates?.filter((template) => template.channel === CommunicationChannel.Sms)

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    if (onChange) {
      onChange(event)
    }
  }

  return (
    <Box>
      {title && (
        <Typography variant="body2" gutterBottom>
          {title}
        </Typography>
      )}
      <FormControl disabled={disabled} fullWidth>
        <Select
          sx={{
            backgroundColor: 'background.paper',
          }}
          size="medium"
          required={required}
          variant={variant}
          startAdornment={<InputAdornment position="start">{icon}</InputAdornment>}
          displayEmpty={true}
          name={name}
          defaultValue={defaultValue}
          value={value !== 0 ? value?.toString() : ''}
          onChange={handleSelectChange}
          MenuProps={{
            slotProps: {
              paper: {
                sx: {
                  borderRadius: '8px',
                },
              },
            },
          }}
        >
          <MenuItem value={''}>
            <Typography variant="body2">{placeholder}</Typography>
          </MenuItem>
          {emailTemplates && emailTemplates?.length > 0 && <ListSubheader sx={{ fontWeight: 600 }}>Epost</ListSubheader>}
          {emailTemplates?.map((template) => (
            <MenuItem key={template.id} value={template.id}>
              <Typography variant="body2">{template.title}</Typography>
            </MenuItem>
          ))}
          <ListSubheader sx={{ fontWeight: 600 }}>Sms</ListSubheader>
          {smsTemplates?.map((template) => (
            <MenuItem key={template.id} value={template.id}>
              <Typography variant="body2">{template.title}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default AlertTemplateSelectField
